module.exports = __webpack_public_path__ + "img/ocean-protocol.0acf6013.svg";